import range from 'lodash-es/range';
import reduce from 'lodash-es/reduce';

const iterator = (steps: number, template: (val: number) => string): string => reduce(range(steps), (css, step) => css.concat(template(step)), '');

export default iterator;
